import { RouterProvider } from 'react-router-dom'
import { ThemeProvider } from '@/providers/theme-provider'
import { ColorThemeProvider } from '@/contexts/color-theme-context'
import { QueryProvider } from '@/providers/query-provider'
import { AuthProvider } from '@/contexts/auth-context'
import { ProjectProvider } from '@/contexts/project-context'
import { SidebarProvider } from '@/contexts/sidebar-context'
import { GlobalFetchingBar } from '@/components/shared/global-fetching-bar'
import { TooltipProvider } from '@/components/ui/tooltip'
import { router } from '@/routes'
import '@/i18n'

export function App() {
  return (
    <ThemeProvider>
      <ColorThemeProvider>
        <QueryProvider>
          <GlobalFetchingBar />
          <AuthProvider>
            <ProjectProvider>
              <SidebarProvider>
                <TooltipProvider>
                  <RouterProvider router={router} />
                </TooltipProvider>
              </SidebarProvider>
            </ProjectProvider>
          </AuthProvider>
        </QueryProvider>
      </ColorThemeProvider>
    </ThemeProvider>
  )
}
